<template>
  <LawForm :element="law" :onSubmit="submit"></LawForm>
</template>

<script>
import LawForm from './law-form.vue';
import { busEvent } from '../events/bus';
import { LawModel } from '../../store/law-module';

export default {
  name: 'CreateLaw',
  components: {
    LawForm,
  },
  data: () => ({
    law: { ...LawModel },
  }),
  methods: {
    submit() {
      const store = this.$store;
      store.dispatch('law/create', {
        appId: this.$route.params.appId,
        body: this.law,
      })
        .then((law) => {
          busEvent.$emit('succesPopupCreated', 'Law created');
          this.$router.push({
            name: 'Edit Law',
            params: {
              appId: this.$route.params.appId,
              lawId: law.id,
            },
          });
        });
    },
  },
};
</script>
